import React, {useState} from 'react';
import {Box, Flex, Container, Heading, Highlight, Image, Text} from "@chakra-ui/react";
import banner from "../../assets/img/skillsBanner.webp"
import banner2 from "../../assets/img/skillsBanner2.webp"

const OurSkills = () => {
    const [photoOne, setPhotoOne] = useState(false)
    const [photoTwo, setPhotoTwo] = useState(false)
    return (
        <>
            <Container maxW="container.xl" p={{base: "0", md: "4"}}>
                <Flex my="70px" alignItems="center" w="full" bg="#EEEEEE" borderRadius="20px"
                      p={{base: "36px 24px", lg: "99px 38px"}}
                      flexDir={{base: "column-reverse", lg: "row"}}>
                    <Box maxW={{base: "full", lg: "70%"}} mr={{base: "0", lg: "50px", xl: "100px"}} bg="#FFFFFF"
                         border="1px solid #E9ECED" borderRadius="24px"
                         boxShadow="0px 2px 4px rgba(148, 165, 168, 0.25)"
                         p={{base: "47px 11px 34px", lg: "43px 20px 21px"}}>
                        <Box>
                            <Heading pb={{base: "26px", lg: "9px"}} fontFamily='Raleway' fontWeight="700"
                                     fontSize={{base: "18px", md: "24px"}}
                                     color="#000000" lineHeight={{base: "21px", md: "28px"}}>Пенопластовая модель
                                шкива</Heading>
                            <Text pb={{base: "23px", lg: "29px"}} fontFamily='Raleway' fontWeight="400"
                                  fontSize={{base: "16px", md: "18px"}} color="#000000"
                                  lineHeight={{base: "19px", md: "21px"}}>Пенопласт – легкий материал, который легко
                                поддается обработке, что дает возможность изготовлению сложных изделий. Все
                                пенопластовые модели изготавливаются на специально-оборудованном станке. </Text></Box>
                        <Flex w="full" flexDir={{base: "column", lg: "row"}}>
                            <Box pos="relative" overflow="hidden" borderRadius="12.8px"
                                 onMouseOver={() => setPhotoOne(true)}
                                 onMouseEnter={() => setPhotoOne(true)}
                                 onMouseLeave={() => setPhotoOne(false)}
                            >
                                <Image w="full" h={{base: "256px", lg: "full"}} src={banner} alt=""
                                       transform={photoOne ? 'scale(1.1)' : 'scale(1)'}
                                       transition={photoOne ? ".4s" : ".4s"}
                                />
                                <Flex
                                    transform={photoOne ? "translateY(100%)" : "translateY(0)"}
                                    transition={photoOne ? ".4s" : ".4s"}
                                    p="14px 10px"
                                    fontFamily='Raleway' fontWeight="600" fontSize="22px"
                                    textShadow="0px 3.65714px 3.65714px rgba(0, 0, 0, 0.25);" color="#FAFAFA"
                                    alignItems="end" w="full" h="70%"
                                    pos="absolute" bottom="0" left="0" lineHeight="100%"
                                    bg="linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.9) 100%);">
                                    Пенопластовая модель шкива
                                </Flex>
                            </Box>
                            <Box pos="relative" overflow="hidden" ml={{base: "0", lg: "11.4px"}}
                                 mt={{base: "25.56px", lg: "0"}} borderRadius="12.8px"
                                 onMouseOver={() => setPhotoTwo(true)}
                                 onMouseEnter={() => setPhotoTwo(true)}
                                 onMouseLeave={() => setPhotoTwo(false)}
                            >
                                <Image w='full' h={{base: "257.68px", lg: "full"}} src={banner2} alt=""
                                       transform={photoTwo ? 'scale(1.1)' : 'scale(1)'}
                                       transition={photoTwo ? ".4s" : ".4s"}
                                />
                                <Flex transform={photoTwo ? "translateY(100%)" : "translateY(0)"}
                                      transition={photoTwo ? ".4s" : ".4s"}
                                      p="14px 10px" fontFamily='Raleway' fontWeight="600"
                                      fontSize={{base: "16px", lg: "12px"}}
                                      textShadow="0px 3.65714px 3.65714px rgba(0, 0, 0, 0.25);" color="#FAFAFA"
                                      alignItems="end" w="full" borderRadius="12.8px" h="70%" lineHeight="100%"
                                      pos="absolute" bottom="0" left="0"
                                      bg="linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.9) 100%);">
                                    Пенопластовая модель, покрытая огнеупорной краской, готовая к заливке
                                </Flex>
                            </Box>
                        </Flex>
                    </Box>
                    <Box w={{base: "full", lg: "40%"}} mb={{base: "11px", lg: "0"}}
                         mr={{base: "0", lg: "78px"}}>
                        <Text pb={{base: "10px", lg: "4px"}} fontFamily='Raleway' fontWeight="400"
                              fontSize={{base: "18px", md: "24px"}} color="#000000"
                              lineHeight={{base: "21px", md: "28px"}}>Одним из направлений нашей деятельности
                            является</Text>
                        <Heading fontFamily='Raleway' fontWeight="700"
                                 fontSize={{base: "30px", md: "54px"}} color="#111212"
                                 lineHeight={{base: "30px", md: "54px"}}>
                            <Highlight query={"Отливка Деталей"} styles={{color: "#E92F34"}}>Отливка Деталей из Металла
                                Любой Сложности</Highlight>
                        </Heading>
                    </Box>
                </Flex>
            </Container>
        </>
    );
};

export default OurSkills;
